export default __webpack_public_path__ + "static/media/low-prices-icon.48aeceb0.svg";